import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import {
    reinitAction,
} from 'one-state-choosecaller';
import {
    RESET,
} from 'one-state-subject/src/types';

/**
 * This Fuction will clear data of choose caller epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearChooseCallerEpic = (context: any) => (
    (action$: any) => {
        const { log} = context;
        log.debug(
            "ccw-gadget,choosecaller-epic",
            "Reset-Choosecaller-epic", {
            });
        return action$.pipe(
            ofType(RESET),
            map(action => reinitAction())
        )
    }
);